import { SnackbarStore } from '@yard/stores/snackbar.store'
import { makeAutoObservable } from 'mobx'
import { ContainerLengthBayMappingSubmitProfile } from '../forms/container-length-bay-mapping-form/container-length-bay-mapping-form.profile'
import { ContainerLengthBayMappingStore } from './container-length-bay-mapping.store'

export class ContainerLengthBayMappingsTableUIStore {
  isDialogOpen = false
  dialogEntityId?: string

  constructor(
    private readonly _mappingStore: ContainerLengthBayMappingStore,
    private readonly _snackbarStore: SnackbarStore,
  ) {
    makeAutoObservable(this)
  }

  get mappings() {
    return this._mappingStore.entries
  }

  get existingLengths() {
    return this.mappings.map(mapping => mapping.length)
  }

  get dialogEntity() {
    if (!this.dialogEntityId) return undefined
    return this._mappingStore.getById(this.dialogEntityId)
  }

  loadAll = async () => await this._mappingStore.loadAll()

  openCreateDialog = () => {
    this.dialogEntityId = undefined
    this.isDialogOpen = true
  }

  openEditDialog = (entityId: string) => {
    this.dialogEntityId = entityId
    this.isDialogOpen = true
  }

  closeDialog = () => {
    this.isDialogOpen = false
    this.dialogEntityId = undefined
  }

  save = async (formValues: ContainerLengthBayMappingSubmitProfile, onFinally: () => void) => {
    try {
      const dto = {
        length: Number(formValues.length),
        bayCount: Number(formValues.bayCount),
      }

      if (formValues.id) {
        await this._mappingStore.update(formValues.id, dto)
        this._snackbarStore.showMessage('The container length mapping was updated successfully', 'success')
      } else {
        await this._mappingStore.create(dto)
        this._snackbarStore.showMessage('The container length mapping was created successfully', 'success')
      }

      await this._mappingStore.loadAll()
      onFinally()
    } catch (e) {
      this._snackbarStore.showMessage(
        'An unexpected error occurred while saving the container length mapping',
        'error',
      )
    }
  }

  delete = async (id: string) => {
    try {
      await this._mappingStore.delete(id)
      this._snackbarStore.showMessage('The container length mapping was deleted successfully', 'success')
      await this._mappingStore.loadAll()
    } catch (e) {
      this._snackbarStore.showMessage(
        'An unexpected error occurred while deleting the container length mapping',
        'error',
      )
    }
  }
}
